import React from 'react';
import { DropdownButton, Table } from 'react-bootstrap';
import Time from 'react-time';
import { getOrgTermsContent } from '../../../content/utils.js';
import { ChangeImpactLink, EditChangeImpactLink } from '../../links/index.jsx';
import OwnersList from '../../OwnersList.jsx';
import RatingLabel from '../../RatingLabel.jsx';
import { EyeIcon } from '../../icons/EyeIcon.jsx';
import { EditBlueIcon } from '../../icons/EditBlueIcon.jsx';
import { DeleteBlueIcon } from '../../icons/DeleteBlueIcon.jsx';
import styles from './ChangeImpactTable.module.css';
import CustomMenuItem from '../../CustomMenuItem.jsx';

const ChangeImpactRow = ({
  changeImpact,
  projectId,
  manageProjectEntities,
  archived,
  onDelete,
}) => {
  return (
    <tr key={changeImpact.id}>
      <td>
        <h3>
          <ChangeImpactLink
            projectId={projectId}
            changeImpactId={changeImpact.id}
          >
            {changeImpact.title}
          </ChangeImpactLink>
        </h3>
      </td>
      <td>
        {changeImpact.changeImpactType ? (
          <strong
            className={
              changeImpact.changeImpactType.archived ? 'text-muted' : ''
            }
          >
            {changeImpact.changeImpactType.name}
          </strong>
        ) : (
          '—'
        )}
      </td>
      <td style={{ minWidth: '132px' }}>
        <strong>
          <RatingLabel reverse rating={changeImpact.scale} />
        </strong>
      </td>
      <td style={{ minWidth: '132px' }}>
        <strong>
          <RatingLabel rating={changeImpact.perception} />
        </strong>
      </td>
      <td>
        <strong>{changeImpact.actionPlanStatus || '—'}</strong>
      </td>
      <td>
        <strong>{changeImpact.tasksNumber}</strong>
      </td>
      <td>
        <strong className="flex flex-col flex-align-start">
          {changeImpact.startDate && changeImpact?.endDate ? (
            <React.Fragment>
              <span>
                <Time value={changeImpact.startDate} format="M/D/YY" />
              </span>
              <span>
                <Time value={changeImpact.endDate} format="M/D/YY" />
              </span>
            </React.Fragment>
          ) : (
            '—'
          )}
        </strong>
      </td>
      <td>
        {changeImpact.owners.length ? (
          <OwnersList owners={changeImpact.owners} />
        ) : (
          '—'
        )}
      </td>

      <td>
        <div className="actions flex-inline">
          <DropdownButton
            noCaret
            title=""
            id="id"
            className="btn-more btn btn-default"
          >
            <ChangeImpactLink
              projectId={projectId}
              changeImpactId={changeImpact.id}
            >
              <>
                <CustomMenuItem>
                  <span className="flex">
                    <EyeIcon />
                    <span>&nbsp; View</span>
                  </span>
                </CustomMenuItem>
                <CustomMenuItem divider />
              </>
            </ChangeImpactLink>
            {manageProjectEntities ? (
              <React.Fragment>
                {archived ? (
                  <span
                    className="item"
                    onClick={() =>
                      window.alert(getOrgTermsContent('archivedProjectMessage'))
                    }
                  >
                    <CustomMenuItem>
                      <span className="flex">
                        <EditBlueIcon />
                        <span>&nbsp; Edit</span>
                      </span>
                    </CustomMenuItem>
                    <CustomMenuItem divider />
                  </span>
                ) : (
                  <EditChangeImpactLink
                    projectId={projectId}
                    changeImpactId={changeImpact.id}
                  >
                    <span className="item">
                      <CustomMenuItem>
                        <span className="flex">
                          <EditBlueIcon />
                          <span>&nbsp; Edit</span>
                        </span>
                      </CustomMenuItem>
                      <CustomMenuItem divider />
                    </span>
                  </EditChangeImpactLink>
                )}

                {archived ? (
                  <span
                    className="item"
                    onClick={() =>
                      window.alert(getOrgTermsContent('archivedProjectMessage'))
                    }
                  >
                    <CustomMenuItem>
                      <span className="flex">
                        <DeleteBlueIcon />
                        <span>&nbsp; Delete</span>
                      </span>
                    </CustomMenuItem>
                    <CustomMenuItem divider />
                  </span>
                ) : (
                  <span
                    className="item"
                    onClick={() => onDelete(changeImpact.id)}
                  >
                    <CustomMenuItem>
                      <span className="flex">
                        <DeleteBlueIcon />
                        <span>&nbsp; Delete</span>
                      </span>
                    </CustomMenuItem>
                    <CustomMenuItem divider />
                  </span>
                )}
              </React.Fragment>
            ) : null}
          </DropdownButton>
        </div>
      </td>
    </tr>
  );
};

const ChangeImpactTable = ({
  changeImpacts,
  projectId,
  manageProjectEntities,
  archived,
  onDelete,
}) => {
  return (
    <Table hover className={styles.changeImpactTable}>
      <thead>
        <tr>
          <th>Title</th>
          <th>Type</th>
          <th>Scale</th>
          <th>Perception</th>
          <th>Action Status</th>
          <th>Tasks</th>
          <th>Dates</th>
          <th>Owner</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {changeImpacts.map((changeImpact) =>
          ChangeImpactRow({
            changeImpact,
            projectId,
            manageProjectEntities,
            archived,
            onDelete,
          })
        )}
      </tbody>
    </Table>
  );
};

export default ChangeImpactTable;
